<template>
  <a-modal
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    title="Coupon distribution"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-item label="直播间号" name="liveId">
        <a-select v-model:value="form.liveId" placeholder="请选择" allow-clear>
          <a-select-option
            v-for="(item, index) in liveRoomSelect"
            :key="index"
            :value="item['id']"
            :label="item['chatGroupName']"
          >
            {{ item['chatGroupName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="新增通知内容">
        <a-button type="dashed" block @click="addContent" style="width: 120px;">
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="通知内容">
        <a-space
          v-for="(item, index) in form.content"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['content', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
            ></a-select>
          </a-form-item>
          <a-form-item
            label="通知内容"
            :name="['content', index, 'value']"
            :rules="{
              required: true,
              message: '请输入'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入"
              auto-size
            />
          </a-form-item>
          <MinusCircleOutlined @click="removeContent(item)" />
        </a-space>
      </a-form-item>

      <!-- <a-form-item label="Notification content（通知内容）" name="content">
        <a-textarea
          v-model:value="form.content"
          :auto-size="{ minRows: 2, maxRows: 5 }"
          placeholder="Please enter the notification content"
        ></a-textarea>
      </a-form-item> -->
      <a-form-item label="展示时长" name="duration">
        <a-radio-group
          v-model:value="form.type1"
          name="type1"
          @change="selectDuration"
        >
          <a-radio value="1">一直</a-radio>
          <a-radio value="2">自定义</a-radio>
        </a-radio-group>
        <a-form-item-rest>
          <a-input-number
            v-model:value="form.duration"
            addon-after="S"
            :disabled="form.type1 != 2"
            min="0"
          ></a-input-number>
        </a-form-item-rest>
      </a-form-item>
      <a-form-item label="发送时间" name="sendTime">
        <a-radio-group
          v-model:value="form.type2"
          name="type2"
          @change="selectSendTime"
        >
          <a-radio value="1">立刻</a-radio>
          <a-radio value="2">自定义</a-radio>
        </a-radio-group>
        <a-form-item-rest>
          <a-date-picker
            v-model:value="form.sendTime"
            :show-time="{ format: 'HH:mm:ss' }"
            placeholder="请选择日期"
            @change="selectDate"
            :disabled="form.type2 != 2"
          />
        </a-form-item-rest>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    PlusOutlined,
    MinusCircleOutlined
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
